export default __webpack_public_path__ + "static/media/proj4mov.c6160387.mp4";